import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    loading: false,
    data: [],
    error: ''
}

export const clientsReducer = createReducer(initialState, {
    FETCH_CLIENTS_REQUEST: (state) => {
        state.loading = true
    },
    FETCH_CLIENTS_SUCCESS: (state, action) => {
        state.loading = false
        state.data = action.payload
    },
    FETCH_CLIENTS_FAILURE: (state, action) => {
        state.loading = false
        state.data = []
        state.error = action.payload
    }
})
